module.exports = __webpack_public_path__ + "media/images/icon_q_1-f3a821b086f77556bcc89bbb04043a22.png";